'use client';

import { useEffect, useState } from 'react';

export const AIToast = () => {
  const [show, setShow] = useState(false);
  const [locale, setLocale] = useState('en');

  useEffect(() => {
    // Get locale from pathname
    const path = window.location.pathname;
    const currentLocale = path.startsWith('/fr') ? 'fr' : 'en';
    setLocale(currentLocale);

    const consent = localStorage.getItem('privacy-consent');
    if (!consent) {
      const timer = setTimeout(() => setShow(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('privacy-consent', 'accepted');
    setShow(false);
  };

  const handleDecline = () => {
    localStorage.setItem('privacy-consent', 'declined');
    setShow(false);
  };

  if (!show) return null;

  const content = {
    en: {
      text: "This site uses tracking technologies. You may opt in or opt out of the use of these technologies.",
      accept: "Accept",
      decline: "Decline"
    },
    fr: {
      text: "Ce site utilise des technologies de suivi. Vous pouvez accepter ou refuser l'utilisation de ces technologies.",
      accept: "Accepter",
      decline: "Refuser"
    }
  };

  const t = locale === 'fr' ? content.fr : content.en;

  return (
    <div className="fixed bottom-6 right-6 z-[9999] max-w-sm w-full animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="bg-[#171717] border border-[#333] rounded-2xl p-6 shadow-2xl backdrop-blur-xl">
        <p className="text-white text-sm leading-relaxed mb-6 font-light">
          {t.text}
        </p>
        <div className="flex gap-3">
          <button
            onClick={handleAccept}
            className="flex-1 bg-white text-black px-4 py-2.5 rounded-xl font-medium hover:bg-gray-200 transition-all active:scale-[0.98]"
          >
            {t.accept}
          </button>
          <button
            onClick={handleDecline}
            className="flex-1 bg-[#262626] text-white px-4 py-2.5 rounded-xl font-medium hover:bg-[#333] transition-all border border-[#444] active:scale-[0.98]"
          >
            {t.decline}
          </button>
        </div>
      </div>
    </div>
  );
};
